module.exports = __webpack_public_path__ + "static/img/空间or美陈-室内设计.fa313b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/goods/CPK10011/空间or美陈-室内设计.png
// module id = JIZN
// module chunks = 1